import { render, staticRenderFns } from "./fieldTrialRegistration.vue?vue&type=template&id=a847bbc4&scoped=true"
import script from "./fieldTrialRegistration.vue?vue&type=script&lang=js"
export * from "./fieldTrialRegistration.vue?vue&type=script&lang=js"
import style0 from "./fieldTrialRegistration.vue?vue&type=style&index=0&id=a847bbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a847bbc4",
  null
  
)

export default component.exports